var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgApple(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 6C0 2.68629 2.68629 0 6 0H42C45.3137 0 48 2.68629 48 6V42C48 45.3137 45.3137 48 42 48H6C2.68629 48 0 45.3137 0 42V6Z",
    fill: "var(--klothed-bgColor)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 6C0.5 2.96243 2.96243 0.5 6 0.5H42C45.0376 0.5 47.5 2.96243 47.5 6V42C47.5 45.0376 45.0376 47.5 42 47.5H6C2.96243 47.5 0.5 45.0376 0.5 42V6Z",
    stroke: "var(--klothed-textColor)",
    strokeOpacity: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2728 19.7465C23.4828 19.7465 22.2599 18.8482 20.9721 18.8807C19.2731 18.9024 17.7147 19.8655 16.8381 21.3914C15.0742 24.454 16.3836 28.9776 18.1043 31.4667C18.9484 32.6787 19.944 34.0423 21.2643 33.999C22.5305 33.9449 23.0067 33.1765 24.5434 33.1765C26.0693 33.1765 26.5022 33.999 27.8441 33.9665C29.2077 33.9449 30.0734 32.7328 30.9067 31.5099C31.8699 30.1031 32.2703 28.7395 32.2919 28.6638C32.2594 28.6529 29.6405 27.6465 29.6081 24.6163C29.5864 22.084 31.6751 20.8719 31.7725 20.8178C30.582 19.0755 28.7531 18.8807 28.1146 18.8374C26.4481 18.7076 25.052 19.7465 24.2728 19.7465ZM27.0865 17.1925C27.79 16.3484 28.2553 15.1688 28.1255 14C27.119 14.0433 25.907 14.671 25.1819 15.5151C24.5326 16.2618 23.9698 17.463 24.1213 18.6102C25.236 18.6967 26.3831 18.0366 27.0865 17.1925Z",
    fill: "var(--klothed-textColor)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgApple);
export default __webpack_public_path__ + "static/media/apple.f5f15a3c5647bf41af0a71478131a80d.svg";
export { ForwardRef as ReactComponent };